import { render } from "./TrainingSectionDocuments.vue?vue&type=template&id=5e59faee&scoped=true"
import script from "./TrainingSectionDocuments.vue?vue&type=script&lang=js"
export * from "./TrainingSectionDocuments.vue?vue&type=script&lang=js"

import "./TrainingSectionDocuments.vue?vue&type=style&index=0&id=5e59faee&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e59faee"]])

export default __exports__